<template>
  <div>
    <span class="text-body-2">
      I am submitting a
    </span>
    <br>
    <v-btn-toggle
      v-model="localValue"
      color="primary"
      class="transparent"
      mandatory
      style="width:100%; min-width: 380px"
    >
      <v-btn
        style="width:33%"
        height="40px"
        small
        value="bug"
      >
        Bug Report
      </v-btn>
      <v-btn
        style="width:33%"
        height="40px"
        small
        value="feature"
      >
        Feature Request
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
  import StringValue from '@/components/form/mixins/stringValue'
  import RequiredRules from '@/components/form/mixins/required'
  export default {
    name: 'FormTypeSelect',
    mixins: [StringValue, RequiredRules],
  }
</script>

<style lang="scss" scoped>

</style>
